import styled from 'styled-components';

export const VoucherContainerStyled = styled.div`
  .product_item {
    margin-bottom: 20px;
    cursor: pointer;
  }
`;
